import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showNotification } from '@mantine/notifications';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { churchesService } from '@/services/churches.service';
import type { ChurchUpdateRequest } from '@/types/churches';

export const useUpdateChurchMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: ChurchUpdateRequest }) => churchesService.updateChurch(id, data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CHURCH, variables.id] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CHURCHES] });
      showNotification({ title: 'Success', message: 'Organization updated successfully', color: 'green' });
    },
  });
};
